import { Action, createReducer, on } from '@ngrx/store';
import { SetCustomization, UpdateProperty } from './customization';

export type Customization = Record<string, string>;

export const customizationFeatureKey = 'customization';

const initState: Record<string, string> = {
  'zalamo-main-background': '#FFFFFF',
  'zalamo-main-menu-background-color': '#E7ECEF',
  'zalamo-main-menu-text-color': '#6B7D7D',
  ...(localStorage.getItem('css-personalization')
    ? JSON.parse(localStorage.getItem('css-personalization'))
    : {}),
};

export const customizationReducer = createReducer(
  initState,
  on(UpdateProperty, (state, props) => {
    console.log('prop update called');

    const current = { ...state };
    current[props.name] = props.value;
    localStorage.setItem('css-personalization', JSON.stringify(current));
    return current;
  }),
  on(SetCustomization, (state, props) => {
    localStorage.setItem(
      'css-personalization',
      JSON.stringify(props.customization)
    );
    return { ...props.customization };
  })
);

export function reducer(state: Customization | undefined, action: Action) {
  return customizationReducer(state, action);
}
